export const environment = {
    production: false,
    apiBaseUrl: 'https://azdev.hcc.com',
    turnstileSiteKey: '1x00000000000000000000AA',
};